<script>
  export let disabled = false;
  export let loading = false;
  export let onSave = () => {};
  /** 'full' = bottom bar; 'compact' = inline beside tab heading */
  export let variant = 'full';
</script>

{#if variant === 'compact'}
  <button
    type="button"
    on:click={onSave}
    disabled={disabled || loading}
    class="inline-flex items-center justify-center flex-shrink-0 bg-green-600 text-white text-sm font-medium px-4 py-1.5 rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
  >
    {#if loading}
      <div class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white mr-2"></div>
      Saving...
    {:else}
      Save Settings
    {/if}
  </button>
{:else}
  <div class="mt-6 pt-6">
    <button
      type="button"
      on:click={onSave}
      disabled={disabled || loading}
      class="w-full bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {#if loading}
        <span class="flex items-center justify-center">
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
          Saving Settings...
        </span>
      {:else}
        Save Settings
      {/if}
    </button>
  </div>
{/if}
